module.exports = __webpack_public_path__ + "static/media/logo-linkedin.5b1a3c52.svg";